import { serverHost } from "variables/serverdata";

export const fetchDomains = async () => {
  try {
    const token = getAuthToken();
    const res = await fetch(
      `${serverHost}/get_rows?table=v_domains&page=1&pageSize=1000`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const data = await res.json();

    if (!Array.isArray(data.results)) return [];

    return data.results.map((d) => ({
      label: d.domain_name,
      value: d.domain_uuid,
    }));

  } catch (err) {
    console.error("Error fetching domains:", err);
    return [];
  }
};

export function getAuthToken() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return localStorage.getItem("token");
    const parsed = JSON.parse(raw);
    return parsed?.access_token || parsed?.token || parsed?.accessToken || null;
  } catch (e) {
    console.error("Failed to parse localStorage user:", e);
    return localStorage.getItem("token");
  }
}

// PURE function: no React, no state
export const sortRows = (data, sortConfig) => {
  if (!sortConfig?.key) return data;

  const { key, direction } = sortConfig;

  return [...data].sort((a, b) => {
    let aVal = a[key];
    let bVal = b[key];

    if (typeof aVal === "string") aVal = aVal.toLowerCase();
    if (typeof bVal === "string") bVal = bVal.toLowerCase();

    if (aVal == null) return 1;
    if (bVal == null) return -1;

    if (aVal < bVal) return direction === "asc" ? -1 : 1;
    if (aVal > bVal) return direction === "asc" ? 1 : -1;
    return 0;
  });
};

